export const SurveySessionCodes = {
  SURVEY_ALREADY_COMPLETED_CODE: 'SURVEY_ALREADY_COMPLETED',
} as const;

export const SurveySessionMessages = {
  SURVEY_ALREADY_COMPLETED_MESSAGE: 'Survey has already been completed.',
  INSURANCE_ALREADY_SUBMITTED_MESSAGE: 'Insurance has already been submitted.',
} as const;
